import { render, staticRenderFns } from "./EditCallRecording.vue?vue&type=template&id=fefdec8a&"
import script from "./EditCallRecording.vue?vue&type=script&lang=js&"
export * from "./EditCallRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports